import { lazy } from 'react';

const ShopgateCommerceWidgetsImage = lazy(() => import('Image'))

const ShopgateCommerceWidgetsImageSlider = lazy(() => import('ImageSlider'))

const ShopgateCommerceWidgetsHtml = lazy(() => import('Html'))

const ShopgateCommerceWidgetsProductSlider = lazy(() => import('ProductSlider'))

const ShopgateCommerceWidgetsCategoryList = lazy(() => import('CategoryList'))

const ShopgateCommerceWidgetsProductList = lazy(() => import('Products'))

const ShopgateCommerceWidgetsLiveshopping = lazy(() => import('Liveshopping'))

const ShopgateCommerceWidgetsDropdownNavigation = lazy(() => import('NestedCategoryFilter'))

export default {
  '@shopgate/commerce-widgets/image': ShopgateCommerceWidgetsImage,
  '@shopgate/commerce-widgets/image_slider': ShopgateCommerceWidgetsImageSlider,
  '@shopgate/commerce-widgets/html': ShopgateCommerceWidgetsHtml,
  '@shopgate/commerce-widgets/product_slider': ShopgateCommerceWidgetsProductSlider,
  '@shopgate/commerce-widgets/category_list': ShopgateCommerceWidgetsCategoryList,
  '@shopgate/commerce-widgets/product_list': ShopgateCommerceWidgetsProductList,
  '@shopgate/commerce-widgets/liveshopping': ShopgateCommerceWidgetsLiveshopping,
  '@shopgate/commerce-widgets/dropdown_navigation': ShopgateCommerceWidgetsDropdownNavigation,
};
